import React, { useState } from "react";
import { Button, Layout, message, Select, Tooltip } from "antd";
import Cookies from "js-cookie";
import axios from 'axios';
import { Redirect, Link } from "react-router-dom";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import './PreviewReview.css';
const { Header, Content } = Layout;
 
const PreviewReview = () => {
    const jwtToken = Cookies.get("jwt_token");
    const userLogin = Cookies.get("UserLogin");
 
    const [file, setFile] = useState(null)
    const [data, getData] = useState(null)
    const [period, setperiod] = useState([])
    const [totalJou, setotalJou] = useState(0)
    const [dataPortal, getDataPortal] = useState([])
    const [delta, GetDelta] = useState(null)
    const [uploadingJou, setUploadingJou] = useState(false)
    const [uploadingPor, setUploadingPor] = useState(false)
    const [disDro, setDisDro] = useState(true)
    const [msg, setMsg] = useState("Please upload journal file first")
    const [errmsg, setFileErrmsg] = useState()
    var bool = 0;
 
    if (jwtToken === undefined) {
        return <Redirect to="/" />;
    }
 
    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile.type === 'application/pdf') {
            setFile(selectedFile);
        } else {
            setFile(null);
            message.error('Please upload a valid PDF file.');
        }
    };
 
    const openJouFileInPopup = () => {
        if (file) {
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank', 'width=1000,height=500');
        }
    };
 
    const handleJouUpload = () => {
        if (!file) {
            setFileErrmsg("*Please upload a file")
        }
        else {
            setUploadingJou(true);
            const formData = new FormData();
            formData.append('file', file);
            axios.post(`${process.env.REACT_APP_BASE_URL}PreviewReview/PayrollJournalData`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${jwtToken}`,
                }
            })
                .then((response) => {
                    const resdata = response.data
                    getData(resdata);
                    setperiod(resdata.payPeriod)
                    const dic = resdata.hoursDictionary
 
                    if (resdata.totalValue == "") {
                        let totalValue = 0;
                        for (const key in dic) {
                            if (dic.hasOwnProperty(key)) {
                                const value = dic[key];
                                // Remove commas, trim leading/trailing spaces, and convert to a float number
                                const numericValue = parseFloat(value.replace(/,/g, '').trim());
                                // Check if it's a valid number before adding
                                if (!isNaN(numericValue)) {
                                    totalValue += numericValue;
                                }
                            }
                        }
                        setotalJou(totalValue)
                    }
                    else {
                        setotalJou(parseFloat(resdata.totalValue.replace(/,/g, '')))
                    }
                    setDisDro(false)
                    setMsg()
                    message.success('Uploaded successfully.');
                    setUploadingJou(false)
                    getDataPortal([])
                    GetDelta([])
                })
                .catch((error) => {
                    message.error('Error while uploading file');
                    setUploadingJou(false)
                    setperiod([])
                })
        }
    };
 
    const handleUploadPortal = async (props) => {
 
        let value = props.value;
        let url;
 
        if (value === "Weekly") {
            url = `${process.env.REACT_APP_BASE_URL}PreviewReview/PortalData?frequency=W&payperiod=${period}`;
 
        }
        else {
            url = `${process.env.REACT_APP_BASE_URL}PreviewReview/PortalData?frequency=B&payperiod=${period}`;
 
        }
        setUploadingPor(true)
        const res = await axios.get(url,
            {
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                }
            })
            .then((response) => {
                const resdata = response.data
                getDataPortal(resdata);
                bool = 1
                if (bool == 1) {
                    const difference = totalJou - resdata.companytotal;
                    GetDelta(difference.toFixed(4))
                }
                message.success('Succes...');
                setUploadingPor(false);
            })
            .catch((error) => {
                message.error("Error while fetching data")
                setUploadingPor(false);
                getDataPortal([])
            });
    };
 
    return (<>
        <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
            <SideNavBar />
            <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
                <Header className="preview-header-class"><Navbar /></Header>
                <Content className="preview-content">
                    <div className="previewallpages-class">
                        <Link to="/payrollhoursaudit"><Button className="preview-page-button">Payroll Hours Audit</Button></Link>
                        <Button className="currentpreview-button">Preview/Review</Button>
                        <Link to="/payrollchecklist"> <Button className="preview-page-button">Payroll Checklist</Button></Link>
                        <Link to="/audit"><Button className="preview-page-button">Selected Crawling</Button></Link>
                        {/* <Link to="/activitylog"><Button className="preview-page-button">Activity Log</Button></Link> */}
                    </div>
                    <div className="frequency-preview-class">
                        <div className="payrolljournal-file">
                            <div>
                                <input type="file" accept=".pdf" onChange={handleFileChange} />
                                {file ? file && (
                                    <div style={{ marginTop: "3%", marginLeft: "1px" }}>
                                        <a onClick={openJouFileInPopup} disabled={!file}>
                                            {file.name}
                                        </a>
                                    </div>
                                ) : <div style={{ marginTop: "3%", marginLeft: "1px", color: "red" }} >{errmsg}</div>
                                }
 
                            </div>
                            <Button onClick={handleJouUpload} loading={uploadingJou} className="upload-file">Upload</Button>
                            <Tooltip placement="bottom" color="rgba(0, 39, 122, 1)" title={msg}>
                                <Select
                                    labelInValue
                                    defaultValue={{
                                        value: 'Select Frequency',
                                        label: 'Select Frequency',
                                    }}
                                    style={{
                                        width: 170
                                    }}
                                    onSelect={handleUploadPortal}
                                    allowClear
                                    options={[
                                        {
                                            value: 'Weekly',
                                            label: 'Weekly',
                                        },
                                        {
                                            value: 'Bi-weekly',
                                            label: 'Bi-weekly',
                                        },
                                    ]}
                                    className="preview-frequency-select"
                                    disabled={disDro}
                                    loading={uploadingPor}
                                />
                            </Tooltip>
                        </div>
 
                    </div>
 
                    <div className="portal-journal-class">
                        <div className="whole-table-class">
                            <div className="portal-journal-table">
                                <div className="portal-data-class">
                                    <div className="portal-journal-heading">
                                        <p className="data-heading-class">Hours- Payroll Journal</p>
                                    </div>
 
                                    <div className="actualdata-row-jou">
                                        <div className="data-columns-od">
                                            {data && (
                                                <div >
 
                                                    <div style={{ width: "90%", marginTop: "2%" }}>
                                                        {Object.entries(data.hoursDictionary).map(([key, value]) => (
                                                            <div style={{ display: "flex", width: "100%" }}>
                                                                <div className="data-row-names" > <p className="datarow-heading" key={key}>{key.charAt(0).toUpperCase() + key.slice(1)}</p></div>
                                                                <div className="original-data" > <p className="datarow-heading" key={key}>{value}</p></div>
                                                            </div>
 
                                                        ))}
                                                    </div>
                                                    {/* <br /> */}
                                                    <div className="total-company-class">
                                                        <p className="totals-company-heading" style={{ marginLeft: "4%" }}>Company Totals: &emsp; {totalJou}</p>
                                                        <p className="totals-company-heading" style={{ marginLeft: "4%" }}>Total Persons: &emsp; {data.companyTotals[0]}</p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="payroll-journal-class">
                                    <div className="portal-journal-heading">
                                        <p className="data-heading-class">Hours - Final Payroll Input File</p>
                                    </div>
 
                                    <div className="actualdata-row">
                                        <div className="data-columns">
                                            <div className="data-row-names">
                                                <p className="datarow-heading">Regular</p>
                                                <p className="datarow-heading">Over Time</p>
                                                <p className="datarow-heading">DT</p>
                                                <p className="datarow-heading">PTO</p>
                                                <p className="datarow-heading">Sick</p>
                                            </div>
                                            <div className="total-company-class">
                                                <p className="totals-company-heading" style={{ marginLeft: "4%" }}>Company Totals: &emsp; {dataPortal.companytotal}</p>
                                                <p className="totals-company-heading" style={{ marginLeft: "4%" }}>Total Persons: &emsp; {dataPortal.totalPersons} </p>
                                            </div>
                                        </div>
                                        <div className="original-data">
                                            <p className="datarow-heading">{dataPortal.rt}</p>
                                            <p className="datarow-heading">{dataPortal.ot}</p>
                                            <p className="datarow-heading">{dataPortal.dt}</p>
                                            <p className="datarow-heading">{dataPortal.pto}</p>
                                            <p className="datarow-heading">{dataPortal.sick}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h3 className="delta-heading" >Delta: &emsp; {delta} </h3>
                    </div>
                </Content>
            </Layout>
        </Layout>
    </>)
 
}
export default PreviewReview;